export default {
  apiKey: process.env.APOLLO_ENGINE_API_KEY, // Set your Apollo Engine API key
  logging: {
    level: 'DEBUG' // Engine Proxy logging level. DEBUG, INFO, WARN or ERROR
  },
  playground: (process.env.npm_config_argv || '').search(/(dev|CUONG)/) >= 0,
  npm_config_argv: process.env.npm_config_argv
};
